/**
 * Generates a consistent random background color for avatars based on a string input
 * Excludes black and white colors to ensure good contrast and visibility
 * @param {string} input - The string to generate color from (usually name or ID)
 * @returns {string} - A CSS color value
 */
const getAvatarColor = (input) => {
	if (!input) {
		return '#6366f1'; // Default indigo color
	}

	// Predefined color palette excluding black, white, and very light/dark colors
	const colors = [
		'#ef4444', // red-500
		'#f97316', // orange-500
		'#f59e0b', // amber-500
		'#eab308', // yellow-500
		'#84cc16', // lime-500
		'#22c55e', // green-500
		'#10b981', // emerald-500
		'#06b6d4', // cyan-500
		'#0ea5e9', // sky-500
		'#3b82f6', // blue-500
		'#6366f1', // indigo-500
		'#8b5cf6', // violet-500
		'#a855f7', // purple-500
		'#d946ef', // fuchsia-500
		'#ec4899', // pink-500
		'#f43f5e', // rose-500
		'#64748b', // slate-500
		'#6b7280', // gray-500
		'#78716c', // stone-500
		'#dc2626', // red-600
		'#ea580c', // orange-600
		'#d97706', // amber-600
		'#ca8a04', // yellow-600
		'#65a30d', // lime-600
		'#16a34a', // green-600
		'#059669', // emerald-600
		'#0891b2', // cyan-600
		'#0284c7', // sky-600
		'#2563eb', // blue-600
		'#4f46e5', // indigo-600
		'#7c3aed', // violet-600
		'#9333ea', // purple-600
		'#c026d3', // fuchsia-600
		'#db2777', // pink-600
		'#e11d48', // rose-600
	];

	// Create a simple hash from the input string
	let hash = 0;
	for (let i = 0; i < input.length; i++) {
		const char = input.charCodeAt(i);
		hash = (hash << 5) - hash + char;
		hash = hash & hash; // Convert to 32-bit integer
	}

	// Use the hash to select a color from the palette
	const colorIndex = Math.abs(hash) % colors.length;
	return colors[colorIndex];
};

export default getAvatarColor;
